import { ButtonCard, Container } from "./styles";

interface ButtonProps {
    tipos: string[]
    selected?: any,
    setSelected?: any,    
}

export default function ProposalButtons({selected, setSelected, tipos}:ButtonProps) {

    return(
        <Container>            
            {tipos.map((tipo) => (
                <ButtonCard 
                    key={tipo}
                className={selected === tipo ? 'selected' : ''}
                onClick={() => setSelected(tipo)}
            >
                {tipo}
                </ButtonCard>         
            ))}
        </Container>
    )
}